
import { AxiosHelper } from '../helpers/AxiosHelper';


const List = async (formData: FormData) => {
    return AxiosHelper.post('/SystemSettings/List', formData);
}

const Edit = async (formData: FormData) => {
    return AxiosHelper.post('/SystemSettings/Edit', formData);
}

const TestSendingEmail = async (formData: FormData) => {
    return AxiosHelper.post('/SystemSettings/TestSendingEmail', formData);
}


const SystemSettingsService = {
    List,
    Edit,
    TestSendingEmail
}

export default SystemSettingsService;